import { z } from 'zod';
/*
  Severity defines the available severity levels for scans.
*/
export var Severity;
(function (Severity) {
    Severity["Low"] = "low";
    Severity["Medium"] = "medium";
    Severity["High"] = "high";
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
/*
  severityLabelMap provides a mapping from Severity enum values to their display labels.
  Used for consistent label formatting across the application.
*/
export const severityLabelMap = {
    [Severity.Low]: 'Low',
    [Severity.Medium]: 'Medium',
    [Severity.High]: 'High',
    [Severity.Critical]: 'Critical',
};
export const severityOptions = [
    { value: Severity.Low, label: severityLabelMap[Severity.Low] },
    { value: Severity.Medium, label: severityLabelMap[Severity.Medium] },
    { value: Severity.High, label: severityLabelMap[Severity.High] },
    { value: Severity.Critical, label: severityLabelMap[Severity.Critical] },
];
/*
  severityOptionsDescending orders Critical → Low, for filter dropdowns
  where the most severe option should surface first. Ascending
  severityOptions stays the default for floor pickers (e.g. minimum
  severity selects).
*/
export const severityOptionsDescending = [
    ...severityOptions,
].reverse();
/*
  severitySchema is the Zod schema for validating severity levels.
  Derived from Severity enum to maintain single source of truth.
*/
export const severitySchema = z.enum([
    Severity.Low,
    Severity.Medium,
    Severity.High,
    Severity.Critical,
]);
/*
  SEVERITY_ORDER provides a stable ordering for comparison.
  Higher number = more severe.
*/
export const SEVERITY_ORDER = {
    [Severity.Low]: 1,
    [Severity.Medium]: 2,
    [Severity.High]: 3,
    [Severity.Critical]: 4,
};
//# sourceMappingURL=severity.js.map